export type PlanType = 'monitoring' | 'automated' | 'essentials' | string;

export function getPlanDisplayName(planType: PlanType): string {
  switch (planType) {
    case 'monitoring':
      return 'Safety Monitoring Center';
    case 'automated':
      return 'Automated Monitoring';
    case 'essentials':
      return 'Essential Protection';
    default:
      return 'OK Alone';
  }
}

export function planTypeFromContract(contract: {
  live_monitoring?: number | boolean;
  call_plan?: number | boolean;
} | null | undefined): PlanType {
  if (!contract) {
    return 'essentials';
  }
  if (contract.live_monitoring == 1 || contract.live_monitoring === true) {
    return 'monitoring';
  }
  if (contract.call_plan == 1 || contract.call_plan === true) {
    return 'automated';
  }
  return 'essentials';
}

export function buildPlanAcceptanceConfirmMessage(planName: string, workers: number): string {
  const workerLabel = workers === 1 ? 'Worker' : 'Workers';
  return `Please confirm you accept the ${planName} Plan for ${workers} ${workerLabel}.`;
}

export function confirmPlanAcceptance(planName: string, workers: number): boolean {
  return window.confirm(buildPlanAcceptanceConfirmMessage(planName, workers));
}
